export const TASK_DETAILS_PAGE_ROOT_ID = 'task-details-root-page'
